import { collection, doc, getDocs, orderBy, query, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export interface PostSummary {
  id: string;
  title?: string;
  schoolId?: string;
  status?: string;
  date?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'posts';

export async function listPostsSummary(): Promise<PostSummary[]> {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('date', 'desc'))
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      title: data.title,
      schoolId: data.schoolId,
      status: data.status,
      date: data.date?.toDate ? data.date.toDate() : undefined,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function updatePostStatus(
  id: string,
  status: string
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, { status });
}

